var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWatchLater24Px = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.94531C0 4.54531 3.6 0.945312 8 0.945312C12.4 0.945312 16 4.54531 16 8.94531C16 13.3453 12.4 16.9453 8 16.9453C3.6 16.9453 0 13.3453 0 8.94531ZM7.2 9.74531L11.36 12.3053L12 11.2653L8.4 9.10531V4.94531H7.2V9.74531Z",
    fill: "#ED9902"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWatchLater24Px);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/watch_later_24px.54f0746e3cae75b0e7ec0ad753bdac3d.svg";